var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.22118C0 0.760866 0.369365 0.387711 0.825 0.387711H3.3C3.75563 0.387711 4.125 0.760865 4.125 1.22118V16.2235C4.125 16.6838 4.49437 17.057 4.95 17.057H15.675C16.1306 17.057 16.5 16.6838 16.5 16.2235V13.7231C16.5 13.2628 16.1306 12.8897 15.675 12.8897H10.725C9.3581 12.8897 8.25 11.7702 8.25 10.3893V2.8881C8.25 1.50718 9.3581 0.387711 10.725 0.387711H18.15C19.5169 0.387711 20.625 1.50718 20.625 2.8881V18.7239C20.625 20.1049 19.5169 21.2243 18.15 21.2243H2.475C1.1081 21.2243 0 20.1049 0 18.7239V1.22118ZM16.5 5.3885C16.5 4.92819 16.1306 4.55503 15.675 4.55503H12.375V7.88889C12.375 8.3492 12.7444 8.72236 13.2 8.72236H16.5V5.3885Z",
    fill: "url(#paint0_linear_14471_826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14471_826",
    x1: -0.00000155986,
    y1: 31.4343,
    x2: 21.8776,
    y2: -4.51985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#213F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39CDCC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.3f0b48281492312cd0043838c1e5f4fc.svg";
export { ForwardRef as ReactComponent };